import { api } from './client';
import type { PersonDto, CreatePersonRequest, UpdatePersonRequest } from '../types/person';

export const personsApi = {
  list: (params: { search?: string; type?: string; limit?: number } = {}) =>
    api.get<PersonDto[]>('/persons', {
      search: params.search,
      type: params.type,
      limit: params.limit ?? 50,
    }),

  getById: (id: number) =>
    api.get<PersonDto>(`/persons/${id}`),

  create: (data: CreatePersonRequest) =>
    api.post<number>('/persons', data),

  update: (id: number, data: UpdatePersonRequest) =>
    api.put<void>(`/persons/${id}`, data),

  delete: (id: number) =>
    api.delete<void>(`/persons/${id}`),
};
